<template>
  <!-- Site wrapper -->
  <div>
    <section class="content">
      <!-- Default box -->
      <div class="row ">
        <div class="col-md-12 grid-margin stretch-card">
          <form class="forms-sample">
            <div class="row justify-content-center">
              <div class="col-12">
                <slot name="upload-logotipo">
                  <UploadLogotipo
                    @input="receberDadosUploadLogotipo"
                    uploadFileRef="escritorioLogotipo"
                    :disabled="desabilitarCampos"
                    :codigoImagem="logotipo"
                  />
                  <div div class="avisoDanger text-left mt-1">
                    {{ dadosRetorno.listaDeErros["logotipo"] }}
                  </div>
                  </slot>
              </div>
              <div class="form-group col-md-12 col-lg-12 col-xl-12 mb-4">
                <div>
                  <label v-for="tipoPessoa in comboTiposPessoa" :key="tipoPessoa.id" class="radio-label">
                    <input type="radio" :id="'tipo_pessoa_' + tipoPessoa.id" :value="tipoPessoa.id" v-model="formulario.tipo" :disabled="desabilitarCampos"  @input="limparListaErros()">
                    {{ tipoPessoa.nome }}
                  </label>
                </div>
              </div>
              <slot name="informacoes-campos-adicionais-admin"></slot>

              <InformacoesPessoais
                :pessoaFisica="ehPessoaFisica"
                :desabilitar="desabilitarCampos"
                :listaDeErros="dadosRetorno.listaDeErros"
              />
              <InformacoesEmpresariais
                :pessoaJuridica="ehPessoaJuridica"
                :desabilitar="desabilitarCampos"
                :buscarInformacoesDoCnpj="buscarInformacoesDoCnpj"
                :listaDeErros="dadosRetorno.listaDeErros"
              />
            <slot name="informacoes-adicionais"></slot>
            </div>
          </form>
        </div>
        <!-- card-body ends -->
      </div>
      <!-- card ends -->
    </section>
  </div>
  <!-- ./wrapper -->
</template>

<script>
import Informacoes from './js/informacoes'
export default Informacoes
</script>

<style scoped>
@import "./scss/edicao-escritorio.scss";
</style>
